export default class InviteService {

    $api;
    $sessionService;
    key = 'invite';

    constructor(api, sessionService) {
        this.$api = api;
        this.$sessionService = sessionService;
    }

    get() {
        return sessionStorage.getItem(this.key);
    }

    store(invite) {
        sessionStorage.setItem(this.key, invite);
    }

    remove() {
        sessionStorage.removeItem(this.key);
    }

    exists() {
        return this.get() !== null;
    }

    get headers() {
        return {
            Authorization: `Bearer ${this.$sessionService.get()}`
        };
    }

    inviteValid() {
        return this.invite()
            .then(
                () => Promise.resolve(true)
            )
            .catch(
                () => {
                    this.remove();
                    return Promise.reject(false)
                }
            );
    }

    invite() {
        return this.exists() ? this.getInvite(this.get()) : Promise.reject();
    }

    getInvite(inviteGuid) {
        return this.$api.get(`/permissions/invites/${inviteGuid}`)
            .then(response => response.data)
            .catch((error) => {
                throw error
            })

    }

    // creates an account and accepts the invite
    register(data, invitation) {
        return this.$api.put(
            `/permissions/invites/${invitation}/accept`,
            data
        ).then(
            response => {
                this.$sessionService.store(response.data.login);
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    accept(invitation) {
        return this.$api.put(
            `/permissions/invites/${invitation}/accept`,
            {status: 'accepted'},
            {headers: this.headers}
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    decline(invitation) {
        return this.$api.put(
            `/permissions/invites/${invitation}/decline`,
            {status: 'declined'},
            {headers: this.headers}
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

}
